import defaultHouseImage from "../../assets/images/default-profile-avatar.jpg"

export function getHouseImageUrl(apiImagePath) {
  const imageUrl = apiImagePath ? apiImagePath : defaultHouseImage

  return imageUrl
}

export function getDayOfWeekOptions() {
  return [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ]
}

export function getDayOfMonthOptions() {
  const monthlyOptions = Array.from({ length: 31 }, (_, i) =>
    (i + 1).toString(),
  )

  return monthlyOptions
}
